define("shared/utils/array-filters/get-three-months-of-posts", ["exports", "@ember/utils", "shared/utils/time-helpers/create-moment-in-tz"], function (_exports, _utils, _createMomentInTz) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.getThreeMonthsOfPosts = _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"@ember/utils",0,"shared/utils/time-helpers/create-moment-in-tz"eaimeta@70e063a35619d71f
  /**
   * Get the last three months of posts from an array of posts.
   *
   * @param posts Array of `IgPost` objects
   * @param timeZoneIdentifier Timezone identifier
   *
   * @returns Filtered array, containing posts from the last 3 months
   */
  const getThreeMonthsOfPosts = (posts, timeZoneIdentifier) => {
    const threeMonthsAgo = (0, _createMomentInTz.default)(0, timeZoneIdentifier).subtract(3, 'months').unix();
    return (0, _utils.isPresent)(posts) ? posts.filter(post => post.createdTime > threeMonthsAgo) : [];
  };
  _exports.getThreeMonthsOfPosts = getThreeMonthsOfPosts;
  var _default = _exports.default = getThreeMonthsOfPosts;
});